import styles from './styles.module.scss';

interface LeadFormResponseMessageProps {
  isDeliverable: boolean;
}

export const LeadFormResponse = ({ isDeliverable }: LeadFormResponseMessageProps) => {
  return (
    <div className={styles.response}>
      {isDeliverable ? (
        <h6 className="blue my-2">Thanks! We&#8217;ll be in touch.</h6>
      ) : (
        <>
          <h6 className="blue mb-0">Thank you for contacting us!</h6>
          <p className="font-down-1 blue">
            We aren&#8217;t servicing your area just yet but we hope to soon. We&#8217;ll be in touch!
          </p>
        </>
      )}
    </div>
  );
};
